<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-education-institutes-dialog-create
          v-if="$hasPermissionTo(['create education institutes'])"
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-autocomplete
          v-model="countryFilter"
          :items="countries"
          item-text="name"
          item-value="id"
          label="Country Filter"
          placeholder="Choose country"
          clearable
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in education institutes here"
          append-icon="search"
          label="Search Education Institute"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="filteredEducationInstitutes"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.action="{ item }">
        <setup-education-institutes-dialog-edit
          v-if="$hasPermissionTo(['update education institutes'])"    
          :education-institution="item"
          @updated="loadData"
        />
        <span class="mx-1" />
        <setup-education-institutes-dialog-delete
          v-if="$hasPermissionTo(['delete education institutes'])"    
          :education-institution="item"
          @deleted="loadData"
        />        
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupEducationInstitutesDialogCreate: () => import('@/components/hris/setup/education/institutes/DialogCreate'),
      SetupEducationInstitutesDialogDelete: () => import('@/components/hris/setup/education/institutes/DialogDelete'),
      SetupEducationInstitutesDialogEdit: () => import('@/components/hris/setup/education/institutes/DialogEdit'),
    },
    data () {
      return {
        headers: [
          {
            text: 'Education Institutes',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Country',
            align: 'left',
            value: 'country.name',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        tableLoading: true,
        educationInstitutes: [],
        countries: [],
        countryFilter: null,
      }
    },

    computed: {
      filteredEducationInstitutes () {
        if (this.countryFilter) {
          return this.educationInstitutes.filter(educationInstitutes => {
            return educationInstitutes.country_id === this.countryFilter
          })
        }

        return this.educationInstitutes
      },
    },
    created () {
      this.loadData()
      this.loadCountries()
    },
    methods: {
      loadData () {
        this.$api.hrisEducationInstitutes().list()
          .then(res => {
            this.educationInstitutes = res.data

            this.tableLoading = false
          })
      },
      loadCountries () {
        this.$api.countries().list()
          .then(res => {
            this.countries = _.orderBy(res.data, ['name'], ['asc'])
          })
      },
    },
  }
</script>
